import { ChangeEvent } from 'react'

import Filters from '@/services/Filters/Filters'
import FilterCategories from '@/ts/enums/global/FilterCategories'

function select(
  event: ChangeEvent<HTMLInputElement>,
  category: FilterCategories
) {
  const { checked, dataset } = event.currentTarget
  const id = dataset.id ?? -1

  if (!checked) return Filters.remove(id, category)

  return Filters.add(id, category)
}

export default select
